import {UserRole} from "@/shared/enums/UserRolesEnums";
import AssistedLivingCoachingRetrospective from "@/views/App/Analytics/Retrospective/AssistedLivingCoaching/List.vue";


const routesAnalyticsRetrospective = [
    {
        path: "assisted-living-coaching",
        name: "analyticsRetrospectiveAssistedLivingCoaching",
        component: AssistedLivingCoachingRetrospective,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.ASSISTANT_VQ,
                UserRole.HEAD_OF_PSYCHOSOCIAL_SERVICES,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    }
]

export default routesAnalyticsRetrospective;